"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react"); // A context is basically a way to pass data through the component tree without having to pass props down manually at every level.
// ...we really should be using more of these in this app, but c'est la vie. It's also worth noting that this is less effective
// than it otherwise might be as we're running multiple lists (for multiple pages) and not really doing much more than passing items.
// If we had additional functionality coming through (e.g. registry manipulation a la the examples of Atlaskit lists), this would be
// much more useful and powerful.


var useUseListContext = function useUseListContext(getListLength) {
  var ListContext =
  /*#__PURE__*/
  (0, _react.createContext)(null);

  var _useState = (0, _react.useState)(function () {
    return Symbol('instance-id');
  }),
      instanceId = _useState[0];

  var contextValue = (0, _react.useMemo)(function () {
    return {
      instanceId: instanceId,
      getListLength: getListLength
    };
  }, [instanceId, getListLength]);

  var useListContext = function useListContext() {
    var listContext = (0, _react.useContext)(ListContext);
    if (listContext === null) return; // eslint-disable-next-line consistent-return

    return listContext;
  };

  return {
    instanceId: instanceId,
    contextValue: contextValue,
    ListContext: ListContext,
    useListContext: useListContext
  };
};

var _default = exports["default"] = useUseListContext;